import {
  UPDATE_SEARCH_VALUE,
  CLEAR_USER_LIST,
  CHANGE_CURRENT_PAGE,
  CHANGE_PAGE_SIZE,
  CHANGE_SEARCH_VALUE,
  UPDATE_PAGE_SIZE,
  UPDATE_COUNT_SIZE,
  UPDATE_CURRENT_PAGE,
  UPDATE_USER_LIST,
  FETCH_USERS,
  FETCH_USERS_START,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_ERROR,
  POST_USER,
  POST_USER_START,
  POST_USER_SUCCESS,
  POST_USER_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const clearUserList = () => ({ type: CLEAR_USER_LIST })
const changeSearchValue = (value) => ({ type: CHANGE_SEARCH_VALUE, value })
const changePageSize = (size) => ({ type: CHANGE_PAGE_SIZE, size })
const updateSearchValue = (value) => ({ type: UPDATE_SEARCH_VALUE, value })
const updateUserList = (users) => ({ type: UPDATE_USER_LIST, users })
const updatePageSize = (size) => ({ type: UPDATE_PAGE_SIZE, size })
const updateCountSize = (count) => ({ type: UPDATE_COUNT_SIZE, count })
const updateCurrentPage = (page) => ({ type: UPDATE_CURRENT_PAGE, page })
const incrementPage = () => ({ type: CHANGE_CURRENT_PAGE, value: 1 })
const decrementPage = () => ({ type: CHANGE_CURRENT_PAGE, value: -1 })

/* Async Calls */
const fetchUsers = () => ({ type: FETCH_USERS })
const fetchUsersStart = () => ({ type: FETCH_USERS_START })
const fetchUsersSuccess = () => ({ type: FETCH_USERS_SUCCESS })
const fetchUsersError = (error) => ({ type: FETCH_USERS_ERROR, error })
const startFetchUsersAsync = buildAsyncAction(
  FETCH_USERS,
  FETCH_USERS_START,
  [FETCH_USERS_SUCCESS, FETCH_USERS_ERROR]
)

const postUser = (user, role) => ({ type: POST_USER, user, role })
const postUserStart = () => ({ type: POST_USER_START })
const postUserSuccess = () => ({ type: POST_USER_SUCCESS })
const postUserError = (error) => ({ type: POST_USER_ERROR, error })
const startPostUserAsync = buildAsyncAction(
  POST_USER,
  POST_USER_START,
  [POST_USER_SUCCESS, POST_USER_ERROR]
)

export {
  incrementPage,
  decrementPage,
  changePageSize,
  changeSearchValue,
  updatePageSize,
  updateCountSize,
  updateCurrentPage,
  updateUserList,
  updateSearchValue,
  clearUserList,
  fetchUsers,
  fetchUsersStart,
  fetchUsersSuccess,
  fetchUsersError,
  startFetchUsersAsync,
  postUser,
  postUserStart,
  postUserSuccess,
  postUserError,
  startPostUserAsync,
}
